<template>
  <table class="info__table">
    <tbody>
      <tr>
        <th>求人<br class="is-sp">ID</th>
        <td>{{ order.order_number }}</td>
      </tr>
      <tr>
        <th>職種</th>
        <td>{{ order.displayed_wanted_jobs }}</td>
      </tr>
      <tr>
        <th>施設<br class="is-sp">形態</th>
        <td>{{ order.hospital_workplace_type }}</td>
      </tr>
      <tr>
        <th>勤務地</th>
        <td>
          {{ order.work_location }}
          <div id="office_map" style="height: 300px; z-index: 0;" v-show="this.isDisplayedMap">
          </div>
        </td>
      </tr>
      <tr>
        <th>雇用<br class="is-sp">形態</th>
        <td>{{ order.employment_type }}</td>
      </tr>
      <tr>
        <th>仕事<br class="is-sp">内容</th>
        <td>{{ order.displayed_fulltime_job_categories }}</td>
      </tr>
      <tr>
        <th>求人<br class="is-sp">概要</th>
        <td style="white-space: pre-wrap;">{{ order.work_contents_memo }}</td>
      </tr>
      <tr>
        <th>勤務<br class="is-sp">時間</th>
        <td style="white-space:pre-wrap;">{{ order.job_time }}</td>
      </tr>
      <tr>
        <th>休日</th>
        <td>{{ order.displayed_fulltime_off_days_of_weeks }}</td>
      </tr>
      <tr>
        <th>休暇</th>
        <td>{{ order.fulltime_off_days }}</td>
      </tr>
      <tr>
        <th>想定<br class="is-sp">年収</th>
        <td style="white-space:pre-wrap;">{{ order.displayed_expected_salary }}</td>
      </tr>
      <tr>
        <th>想定年収の<br class="is-sp">見込み</th>
        <td style="white-space:pre-wrap;">{{ order.expected_annual_salary }}</td>
      </tr>
      <tr>
        <th>試用<br class="is-sp">期間</th>
        <td style="white-space:pre-wrap;" v-html="order.trial_period"></td>
      </tr>
      <tr>
        <th>福利<br class="is-sp">厚生</th>
        <td style="white-space:pre-wrap;">
          <div class="cassette__top orderDetail">
            <div>
              <span class="tags tags--welfare" v-for="tag of order.displayed_welfare_tags">{{ tag }}</span>
            </div>
          </div>{{ order.welfare_detail }}
        </td>
      </tr>
      <tr>
        <th>資格・<br class="is-sp">経験</th>
        <td style="white-space:pre-wrap;">
          <div class="cassette__top orderDetail">
            <div>
              <span class="tags tags--characteristic"
                v-for="tag of order.displayed_qualification_tags">{{ tag }}</span>
            </div>
          </div>{{ order.qualification_detail }}
        </td>
        </tr>
      <tr>
        <th>残業<br class="is-sp">時間</th>
        <td style="white-space:pre-wrap;">{{ order.discretionary_labor_system_memo }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'InformationTableHellowork',
  props: ['order', 'isDisplayedMap'],
}
</script>